import {
  useAlertsManagementListFilter,
  useSetAlertsManagementListFilter,
} from '@gripp/shared-logic';
import { useTranslation } from 'react-i18next';
import { EntitySearchInput } from './entitySearchInput';

export const AlertsManagementSearchInput = () => {
  const { t } = useTranslation();
  const { data: filter } = useAlertsManagementListFilter();
  const { mutateAsync } = useSetAlertsManagementListFilter();

  const onSearch = async (keyword: string) => {
    if (!filter) return;
    filter.keyword = keyword;
    await mutateAsync(filter);
  };

  return (
    <EntitySearchInput
      filter={filter}
      onSearch={onSearch}
      placeholder={t('alertsManagement.filter.searchPlaceholder')}
    />
  );
};
